import React from 'react';
import 'leaflet/dist/leaflet.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Sidebar from '../components/layout/Sidebar';
import Topbar from '../components/layout/Topbar';
import DataView from '../components/route-management/DataView';
import MapPage from '../components/route-management/MapPage';
import NetworkMapPage from '../components/route-management/NetworkMapPage';
import RoutesPage from '../components/route-management/RoutesPage';
import StopsPage from '../components/route-management/StopsPage';
import useRouteManagement from '../hooks/useRouteManagement';

export default function RouteManagementPage() {
  const controller = useRouteManagement();
  const { activeTab } = controller;

  return (
    <div className="flex min-h-screen bg-slate-50 text-slate-900">
      <Sidebar controller={controller} />

      <div className="flex-1 min-w-0 flex flex-col h-screen">
        <Topbar controller={controller} />

        <main className="flex-1 min-h-0 flex flex-col overflow-hidden animate-fade-in">
          {activeTab === 'data' && <DataView controller={controller} />}
          {activeTab === 'stops' && <StopsPage controller={controller} />}
          {activeTab === 'map' && <MapPage controller={controller} />}
          {activeTab === 'network' && <NetworkMapPage controller={controller} />}
          {activeTab === 'routes' && <RoutesPage controller={controller} />}
        </main>
      </div>

      <ToastContainer position="bottom-right" autoClose={2500} theme="light" newestOnTop />
    </div>
  );
}
